import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState, useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { logAuditAction } from '../../../utils/auditLogger';
const ModalCreateMedicion = ({ buscar_cis, handleShowPopup, setSearchTerm, languaje, mode, user, dataUsers, devices, server, setRegisterIsValid, groupSelected, setData, loading, setLoading, setError, setEditActive, editActive, closCreateCisModal }) => {
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const [loadingM, setLoadingM] = useState(false);
  const [IpValid, setIpValid] = useState(true)
  const [matchPassword, setMatchPassword] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [host, sethost] = useState([])
  const [ManttoData, setManttoData] = useState({
    // name_brand:(editActive)?groupSelected.name_brand:"",
    brand_id: (editActive) ? groupSelected.brand_id : null,
    model_id: (editActive) ? groupSelected.model_id : null,
    metric: (editActive) ? groupSelected.metric : "",
    agent_type_id: (editActive) ? groupSelected.agent_type_id : null,
    value_type_id: (editActive) ? groupSelected.value_type_id : null,
    unidad: (editActive) ? groupSelected.unidad : "",
    update_interval_default: (editActive) ? groupSelected.update_interval_default : "",
    oid: (editActive) ? groupSelected.oid : "",
    visible_name: (editActive) ? groupSelected.visible_name : "",
    template_group_default_id: (editActive) ? groupSelected.template_group_default_id : "",
    item_name: (editActive) ? groupSelected.item_name : '',
    template_name: (editActive) ? groupSelected.template_name : "",
    item_key: (editActive) ? groupSelected.item_key : "",
  })

  const reqField = () => {
    return (
      <p className='reqField-gs'>
        *
      </p>
    )
  }
  const [hostName, setHostName] = useState("")
  const [hostLocation, setHostLocation] = useState("")
  const [hostActivate, setHostActivate] = useState(0)
  const levelsActual = dataUsers.data.map(obj => obj.level)
  const iconsActualString = dataUsers.data.map(obj => obj.icon)
  const iconsActual = iconsActualString.map(Number)
  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError, setMsgError] = useState("")
  const [listSearchIP, setListSearchIP] = useState(false)
  // const dataTechs=useFetch('cassia/tech_devices','','','GET',server)
  // const dataProxies=useFetch('zabbix/proxies','','','GET',server)
  // const dataAgents=useFetch('cassia/device_metrics/catalogs/agent_types','','','GET',server)//manda el id 1 para grupos
  // const dataValues=useFetch('cassia/device_metrics/catalogs/value_types','','','GET',server)//manda el id 2 para zonas  
  const dataBrands = useFetch('cassia/device_metrics', '', '', 'GET', server)
  // console.log(dataAgents)

  // const dataAgentsVisible=(!dataAgents.loading?dataAgents.data.data.filter(elemento => elemento.visible === 1):[])
  //       console.log(dataAgentsVisible)
  const [dataModels, setDataModels] = useState({
    data: [],
    loading: true,
    error: null
  })
  // useEffect(()=>{
  //     if(ManttoData.brand_id!=null){
  //       search_marcas(ManttoData.brand_id)
  //     }

  //   },[ManttoData.brand_id])
  const search_marcas = (brand_id) => {
    // setLoadingCis(true)
    setDataModels({
      data: dataModels.data,
      loading: true,
      error: null
    })
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/host_models/by_brand/" + brand_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          // setDataModels(data1);
          setDataModels({
            data: data1,
            loading: false,
            error: null
          })
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };



  function validarIntervalo(valor) {
    const regex = /^\d+(s|m|h)$/;
    return regex.test(valor);
  }
  const handleChange = (e) => {
    const { name, value } = e.target
    if (e.target.name === "criticality") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value === "" ? 0 : (parseInt(value))
        }

      })
    } else if (e.target.name === "metric") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value === "" ? "" : ((value)),
          ['visible_name']: value === "" ? "" : ((value)),
          ['template_name']: value === "" ? "" : ((value)),
          ['item_name']: value === "" ? "" : ((value))
        }

      })
    } else if (e.target.name === "status") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: (value == "Inactivo") ? "Activo" : "Inactivo"
        }

      })
    } else {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value
        }

      })
    }



    if (e.target.name === "ip") {
      if (value == "") {
        setHostLocation("")
        setHostActivate(0)
        setIpValid(true)
        sethost([])
        setHostName("")
        setHostLocation("")
      } else {
        setIpValid(validateIp(value))
      }


    }
  }

  useEffect(() => {

    if (ManttoData.brand_id == null || ManttoData.model_id == null || ManttoData.model_id == null ||
      ManttoData.agent_type_id == null || ManttoData.metric == "" || ManttoData.update_interval_default == ""
      || ManttoData.visible_name == "" || ManttoData.template_group_default_id == "" || ManttoData.item_name == ""
      || ManttoData.template_name == "" || ManttoData.item_key == "" || !validarIntervalo(ManttoData.update_interval_default)
      || !validarTextoMetrica(ManttoData.metric)

    ) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [ManttoData])


  const Registrar = () => {
    let method = 'POST'
    let url_add = ''
    if (editActive) {
      method = 'PUT'
      url_add = groupSelected.id
    }

    let body = {}



    setLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/device_metrics/' + url_add, {
          method: method,
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(ManttoData),
        });
        if (response.ok) {

          const data1 = await response.json();
          setLoading(false)
          // Manejo de la respuesta
          setData(data1)
          buscar_cis()
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter(((editActive) ? lang[languaje]['regEditCorr'] : lang[languaje]['regGenCorr'])), '', true)
          // console.log(data1);
          closCreateCisModal()
          setRegisterIsValid(true)

          const timer = setTimeout(() => {
            setRegisterIsValid(false)
            setEditActive(false)
            closCreateCisModal()
          }, 3000);

        } else {
          const data1 = await response.json();
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regNoGenCorr']), data1.detail, false)
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setHostName("")
        setManttoData({ type_id: 0, name: "" })

        setLoading(false)
        // Manejo de errores
        setError(error)
        closCreateCisModal()
        setRegisterIsValid(true)
        //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        const timer = setTimeout(() => {
          setRegisterIsValid(false)
          setEditActive(false)
          closCreateCisModal()
        }, 3000);
        console.error(error);
      }
    };

    fetchDataPost();
  }

  const buscar_host = (ip) => {
    setLoadingM(true)
    const fetchDataPost = async () => {

      try {
        const response = await fetch(server.url + '/api/v1/cassia/ci_elements/search_host/' + ip, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        //   console.log(response)
        if (response.ok) {
          const data1 = await response.json();
          setLoadingM(false)
          if (data1.data.length == 0) {
            sethost([])
            setHostName("")
            setHostLocation("")
            setHostActivate(0)
            setMsgError("La IP no existe o no esta dada de alta")
            setIpValid(false)
          } else {
            setIpValid(true)

          }
          sethost(data1.data)
          setDisabled(true)
        } else {
          const data1 = await response.json();
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const [metricId, setMetricId] = useState(0)
  const changeOption = (option, index) => {
    setMetricId(option.value)
    // console.log(option)
    // let attr=''
    // if(option.filter=='Marcas'){
    //     attr='brand_id'
    // }else if(option.filter=='hostModel'){
    //     attr='model_id'
    // }
    // else if(option.filter=='period'){
    //     attr='agent_type_id'
    // }
    // else if(option.filter=='trigger'){
    //     attr='value_type_id'
    // }

    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         [attr]:option.value===""?0:(parseInt(option.value))
    //     }

    // })
    // setManttoRelation(option.value)

  }

  const [fecha, setDate] = useState('2023-09-28')
  const validateIp = (ip) => {
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let result = ipRegex.test(ip);
    if (result) {
      buscar_host(ip)
    } else {
      setHostLocation("")
      setMsgError("Direccion ip no valida")
      sethost([])
      setHostName("")
      setHostLocation("")
      setHostActivate(0)
    }
    return result;
  };
  const [resultList, setResultList] = useState([])


  //   console.log(resultList)

  const closeListSearch = () => {
    setListSearchIP(false)
  }
  function validarTextoMetrica(valor) {
    const regex = /^[a-zA-Z0-9_-]+$/;
    return regex.test(valor);
  }
  function validarTextoBasico(valor) {
    const regex = /^[a-z0-9.]+$/;
    return regex.test(valor);
  }
  const Eliminar = () => {

    setLoading(true)
    setLoadingM(true)
    const fetchDataPost = async () => {

      try {
        const response = await fetch(server.url + '/api/v1/cassia/device_metrics/active/' + metricId, {
          // const response = await fetch(server.url+'/api/v1/cassia/device_metrics/'+user.id, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify({
            "closed_at": ""
          })
        });
        if (response.ok) {

          const data1 = await response.json();
          setLoadingM(false)
          setLoading(false)
          // Manejo de la respuesta
          setData(data1)
          buscar_cis()
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter(((editActive) ? lang[languaje]['regEditCorr'] : lang[languaje]['regGenCorr'])), '', true)
          logAuditAction(
            editActive ? "Editar" : "Crear",
            `Medición ID: ${metricId}`,
            "Mediciones"
          );
          // console.log(data1);
          closCreateCisModal()

          // console.log(data1);
        } else {
          const data1 = await response.json();
          setLoadingM(false)
          // closDeleteUserModal()
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']), data1.detail, false)

          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        setError(error)
        console.error(error);
      }
    };

    fetchDataPost();

  }
  const { brand_id, model_id, metric, agent_type_id, value_type_id, unidad, update_interval_default, oid, visible_name, template_group_default_id, item_name, template_name, item_key } = ManttoData;
  return (
    <div className="modal-GS-content">
      <div className='card-modal-gs modal-verificate'>
        <div className='head-card-modal-gs'>
          <div className='title-head-card-modal-gs'>
            {((editActive) ? lang[languaje]['editar'].toUpperCase() : lang[languaje]['crear'].toUpperCase()) + ' ' + lang[languaje]['medicion'].toUpperCase()}
          </div>
        </div>
        <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin' }}>

          <div className="form-GS-box">
            <div className="cont-msg-alert-confirm-action">
              <div className="compact-msg-alert-confirm-action">
                <img className='icon-msg-alert' src={"/iconos/warning.png"} alt="Icono" style={{ width: '30px', height: '30px', marginRight: '10px' }} />
                <div className="msg-alert-txt-confirm-action">

                  {'Esta es una version DEMO de SAIMONTECH por lo cual no se pueden crear nuevas metricas, aqui se le proporciona una lista  precargada de metricas que podra dar de alta.'}
                </div>
              </div>

            </div>

            {(!dataBrands.loading && dataBrands.data && dataBrands.data.data && dataBrands.data.data.filter(elemento => elemento.active === 0).length === 0) && (
              <div className="cont-msg-alert-confirm-action" style={{ marginTop: '10px', marginBottom: '15px' }}>
                <div className="compact-msg-alert-confirm-action">
                  <img className='icon-msg-alert' src={"/iconos/warning.png"} alt="Icono" style={{ width: '30px', height: '30px', marginRight: '10px' }} />
                  <div className="msg-alert-txt-confirm-action">
                    {'Se necesitan eliminar mediciones de la tabla para que sean opciones elegibles para esta simulación.'}
                  </div>
                </div>
              </div>
            )}

            {/* <div className="user-box-GS "  style={{height:'10%'}}>
                                     </div> */}
            <div className="user-box-GS " style={{ height: '13%' }}>
              {
                (dataBrands.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <>
                    {(dataBrands.data && dataBrands.data.data && dataBrands.data.data.filter(elemento => elemento.active === 0).length === 0) ? (
                      <div style={{ width: '100%', pointerEvents: 'none', opacity: 0.5 }}>
                        <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''} opt_de={0} origen={'Admin'} data={[]} loading={false} titulo='Metricas' selectFunction={changeOption} index={0}></SelectorAdmin>
                      </div>
                    ) : (
                      <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''} opt_de={(brand_id == null) ? 0 : brand_id} origen={'Admin'} data={dataBrands.data.data.filter(elemento => elemento.active === 0)} loading={dataBrands.loading} titulo='Metricas' selectFunction={changeOption} index={0}></SelectorAdmin>
                    )}
                  </>
              }
              <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['metrica'])}{(metricId == null) ? reqField() : ''}</label>
            </div>

            {/* <div className="user-box-GS "  style={{height:'13%'}}>
                                        {
                                            (dataModels.loading)?<p style={{color:'var(--txt-color)'}}> seleccione una marca. . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(model_id==null)?0:model_id} origen={'Admin'} data={dataModels.data.data}   loading={dataModels.loading}  titulo='hostModel' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['modelo'])}{(model_id==null)?reqField():''}</label>   
                                    </div> */}
            {/* <div className="user-box-GS "  style={{height:'13%'}}>
                                        {
                                            (dataAgents.loading)?<p style={{color:'var(--txt-color)'}}> seleccione una marca. . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(agent_type_id==null)?null:agent_type_id} origen={'Admin'} data={dataAgentsVisible}   loading={dataAgents.loading}  titulo='period' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tipoAgente'])}{(agent_type_id==null)?reqField():''}</label>   
                                    </div> */}
            {/* <div className="user-box-GS "  style={{height:'13%'}}>
                                        {
                                            (dataValues.loading)?<p style={{color:'var(--txt-color)'}}> seleccione una marca. . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(value_type_id==null)?0:value_type_id} origen={'Admin'} data={dataValues.data.data}   loading={dataValues.loading}  titulo='trigger' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tipoVariable'])}{(value_type_id==null)?reqField():''}</label>   
                                    </div> */}

            {/* <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="metric"  type="text" value={metric}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])+' '+capitalizeFirstLetter(lang[languaje]['metrica'])}{(metric=="" || !validarTextoMetrica(metric))?reqField():''}</label>
                                        
                                        {
                                           (metric=="" || validarTextoMetrica(metric))?'':<span className='form-msg-error-admin' style={{bottom: '0%'}}> {'No se permiten acentos, ni elementos especiales, ni guiones bajos, ni vacio '}.</span>
                                        }
                                    </div> */}
            {/* <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="unidad"  type="text" value={unidad}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['unidad'])}</label>
                                        
                                    </div> */}
            {/* <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="update_interval_default"  type="text" value={update_interval_default}
                                    onChange={handleChange}  placeholder='Ejemplos: 30s, 10m, 2h'/>
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['intervaloActualizacion'])}{(update_interval_default=="" || !validarIntervalo(update_interval_default))?reqField():''}</label>
                                        {
                                           (update_interval_default=="" || validarIntervalo(update_interval_default))?'':<span className='form-msg-error-admin' style={{bottom: '0%'}}> {'Intervalo no valido, Ejemplos: 30s, 10m, 2h'}.</span>
                                        }
                                    </div> */}
            {/* <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="oid"  type="text" value={oid}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{'OID'}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>

                                    <input required name="visible_name"  type="text" value={visible_name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombreVisible'])}{(visible_name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="template_group_default_id"  type="number" value={template_group_default_id}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['templateGroup'])}{(template_group_default_id=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="template_name"  type="text" value={template_name}
                                    onChange={handleChange}   />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['templateName'])}{(template_name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="item_name"  type="text" value={item_name}
                                    onChange={handleChange} disabled  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['itemName'])}{(item_name=="")?reqField():''}</label>
                                        
                                    </div>
                                    <div className="user-box-GS"  style={{height:'13%'}}>
                                    <input required name="item_key"  type="text" value={item_key}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['keyItem'])}{(item_key=="" )?reqField():''}</label>
                                        
                                    </div> */}





            <div className="user-box-GS" style={{ height: '33%' }}>
              {
                (loading) ? <LoadSimple></LoadSimple>
                  :
                  <>
                    <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={closCreateCisModal} />
                    <Action disabled={metricId == 0} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={Eliminar} />
                  </>
                // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
              }

              {
                // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCreateMedicion